import { useState, useEffect, useRef } from "react";
import { parseISO, startOfDay, format } from 'date-fns';
import { useApi } from "../hooks/useApi";

export default function Deadline({ setDeadlinepassed }) {
    const [deadline, setDeadline] = useState("");
    const initialized = useRef(false);
    const { apiCall } = useApi();

    useEffect(() => {
        if (!initialized.current) {
            initialized.current = true;
            apiCall(`get_setting`, { params: { setting: 'deadline' } }) // Update with your actual API endpoint
                .then((response) => {
                    if (!response.ok) {
                        throw new Error("Failed to fetch settings");
                    }
                    return response.json();
                }).then((data) => {
                    setDeadline(data.value || '');
                    if (data.value) {
                        const deadlineDate = startOfDay(parseISO(data.value)); // strip time to midnight
                        const today = startOfDay(new Date());
                        setDeadlinepassed(deadlineDate < today);
                    }
                });
        }
    });


    return (
        <div>
            <div className="text-gray-700 font-medium mb-2 text-center">
                Current Deadline: <span className="text-red-600">
                    {deadline ? format(parseISO(deadline), 'dd-MMM-yy').toUpperCase() : ''}
                </span>

            </div>


        </div>
    );
};
